import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { BotComparison } from '../components/BotComparison';
import { SystemMapSection } from '../components/SystemMapSection';
import { LeakSection } from '../components/LeakSection';
import { WorkingExamples } from '../components/WorkingExamples';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Why() {
  usePageTitle('Why | You were right to turn it off | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Why" title="You were right to turn it off." body="Most AI tools sold to agents deserve it. Here is the difference between what you tried and what we run." data-id="element-561" data-mp="91ut5u5ssomf" />
      <BotComparison data-id="element-562" data-mp="11inl57zdd58c" />
      <SystemMapSection surface="ink-900" data-id="element-563" data-mp="11j748s0r9zny" />
      <LeakSection data-id="element-564" data-mp="wrp4266k4341" />
      <WorkingExamples data-id="element-565" data-mp="wr5lqoczvcph" />
      <WhoItIsFor data-id="element-566" data-mp="wqmb7spobqlh" />
      <NextStepPanel title="So who is Viridia to run this for you?" buttonLabel="Why teams hire Viridia" to="/why-viridia" data-id="element-567" data-mp="wqe0a6d42vcx" />
    </>;
}